import styled from 'styled-components';

const PlayPauseButton = styled.button`
    position: absolute;
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        if (layout.top !== undefined) styles += `top: ${typeof layout.top === 'string' ? layout.top : `${layout.top}px`}; `;
        if (layout.right !== undefined) styles += `right: ${typeof layout.right === 'string' ? layout.right : `${layout.right}px`}; `;
        if (layout.bottom !== undefined) styles += `bottom: ${typeof layout.bottom === 'string' ? layout.bottom : `${layout.bottom}px`}; `;
        if (layout.left !== undefined) styles += `left: ${typeof layout.left === 'string' ? layout.left : `${layout.left}px`}; `;
        if (layout.width !== undefined) styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        if (layout.height !== undefined) styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        if (layout.transform) styles += `transform: ${layout.transform}; `;
        return styles;
    }}
    border-radius: 50%;
    background: ${props => props.isPlaying 
        ? 'radial-gradient(circle at 30% 30%, #ff4444 0%, #cc0000 100%)'
        : 'radial-gradient(circle at 30% 30%, #1DB954 0%, #1ed760 100%)'};
    border: 2px solid ${props => props.isPlaying 
        ? 'rgba(255, 68, 68, 0.5)'
        : 'rgba(29, 185, 84, 0.5)'};
    color: white;
    font-size: 1.2rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 
        inset 0 2px 5px rgba(0, 0, 0, 0.3),
        0 2px 8px rgba(0, 0, 0, 0.3);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        transform: scale(1.1);
        box-shadow: 
            inset 0 2px 5px rgba(0, 0, 0, 0.3),
            0 4px 12px rgba(0, 0, 0, 0.4);
    }

    &:active {
        transform: scale(0.95);
    }
`;

export default PlayPauseButton;

